import React, { useState } from "react";
import { arrayOf, number, shape, string } from "prop-types";

import * as S from "./styled";

const ExpandableList = props => {
  const [isSectionOpened, setSectionOpened] = useState(false);
  const handleClick = () => setSectionOpened(currentValue => !currentValue);
  const renderListItem = item => (
    <S.ItemWrapper key={`${item.name}-item`}>
      <S.Link href={item.url}>{item.name}</S.Link>
    </S.ItemWrapper>
  );

  return (
    <S.Wrapper>
      <S.Header href={props.headerUrl}>{props.headerText}</S.Header>
      <S.ExpandedSection>
        {props.list
          .slice(0, props.initialItemNumber)
          .map(listItem => renderListItem(listItem))}
      </S.ExpandedSection>
      {!isSectionOpened && (
        <S.TriggerNode
          aria-expanded={isSectionOpened}
          aria-label={isSectionOpened ? "Hide" : "Show more"}
          aria-pressed={isSectionOpened}
          onClick={handleClick}
        >
          {isSectionOpened ? "- Hide" : "+ Show more"}
        </S.TriggerNode>
      )}
      {isSectionOpened && (
        <S.ExpandedSection>
          <li>
            <S.TriggerNode
              aria-expanded={isSectionOpened}
              aria-label={isSectionOpened ? "Hide" : "Show more"}
              aria-pressed={isSectionOpened}
              onClick={handleClick}
            >
              {isSectionOpened ? "- Hide" : "+ Show more"}
            </S.TriggerNode>
          </li>
          {props.list
            .slice(props.initialItemNumber, props.list.length)
            .map(listItem => renderListItem(listItem))}
        </S.ExpandedSection>
      )}
    </S.Wrapper>
  );
};

ExpandableList.propTypes = {
  list: arrayOf(shape({ name: string, url: string })),
  headerText: string.isRequired,
  headerUrl: string.isRequired,
  initialItemNumber: number
};

ExpandableList.defaultProps = {
  list: [],
  initialItemNumber: 10
};

export default ExpandableList;
